export default "__VITE_ASSET__96d7d08e__"